import PropTypes from 'prop-types'
import React from 'react'
import { formatPhone } from 'SRC/modules/layout/Sidebar/AdsList/functions/functions'

export const Item = ({ id, name, email, phone, image, onRemoveClick, onEditClick }) => (
  <section className='oglasi-agent'>
    <section className='oglasi-agent-info'>
      <div className='oglasi-agent-img' style={{backgroundImage: `url(${image})`}} />
      <div className='oglasi-agent-description'>
        <p>
          <i className='ico ico-top-meni-prijavi-se' style={{ fontSize: 20 }} />
          <span>{name}</span>
        </p>

        {phone ? (
          <p>
            <img src='/icons/Partneri-Telefon.svg' width={20} />
            <span>{formatPhone(phone)}</span>
          </p>
        ) : null}

        {email ? (
          <p>
            <img src='/icons/Partneri-Email.svg' width={20} />
            <span>{email}</span>
          </p>
        ) : null}
      </div>

      <div className='oglasi-agent-actions'>
        <div className='oglasi-agent-action' onClick={onEditClick}>
          <i className='ico-izmijeni-oglas ico' />
        </div>
        <div className='oglasi-agent-action' onClick={() => { onRemoveClick(id) }}>
          <i className='ico-obrisati ico' />
        </div>
      </div>
    </section>
  </section>
)

Item.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  onRemoveClick: PropTypes.func.isRequired,
  onEditClick: PropTypes.func.isRequired
}

Item.defaultProps = {
  desc: []
}
